<div class="w-full h-full flex flex-col">
  <header class="border-b bg-white/70 backdrop-blur sticky top-0 z-10">
    <div class="mx-auto max-w-3xl px-4 py-3 flex items-center justify-between">
      <h2 class="text-lg font-semibold">Chiedi all'assistente virtuale</h2>
    </div>
  </header>

  <main class="flex-1">
    <div #scrollArea class="mx-auto max-w-3xl px-4 py-4 h-full overflow-y-auto">
      <div class="flex flex-col gap-4">
        <ng-container *ngFor="let m of messages()">
          <div class="flex" [class.justify-end]="m.role === 'user'">
            <div class="flex items-end gap-2 max-w-full" [class.flex-row-reverse]="m.role === 'user'">
              <div class="shrink-0 w-8 h-8 rounded-full grid place-items-center text-xs font-semibold"
                   [class.bg-blue-600]="m.role === 'user'"
                   [class.text-white]="m.role === 'user'"
                   [class.bg-gray-300]="m.role !== 'user'"
                   [class.text-gray-900]="m.role !== 'user'">
                {{ m.role === 'user' ? 'U' : 'A' }}
              </div>
              <div [class]="bubbleClasses(m)">{{ m.content }}</div>
            </div>
          </div>
        </ng-container>

        <div *ngIf="isLoading()" class="text-sm text-gray-500 animate-pulse">
          L’assistente sta scrivendo…
        </div>
        <div *ngIf="errore()" class="text-sm text-red-600">
          {{ errore() }}
        </div>
      </div>
    </div>
  </main>

  <footer class="border-t bg-white sticky bottom-0">
    <div class="mx-auto max-w-3xl px-4 py-3">
      <div class="flex items-end gap-2">
        <textarea
          class="w-full resize-none rounded-2xl border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 px-4 py-3 leading-6"
          rows="1"
          placeholder="Scrivi un messaggio…"
          [ngModel]="input()"
          (ngModelChange)="input.set($event)"
          (keydown)="handleKeydown($event)"
        ></textarea>
        <button
          class="rounded-2xl px-4 py-2 font-medium shadow disabled:opacity-50 disabled:cursor-not-allowed
                 bg-blue-600 text-white hover:bg-blue-700 transition"
          (click)="send()"
          [disabled]="!input().trim() || isLoading()"
          aria-label="Invia"
        >
          Invia
        </button>
      </div>
      <p class="mt-2 text-xs text-gray-500">Invio per inviare • Shift+Invio per a capo</p>
    </div>
  </footer>
</div>

